import Profile from './StudentProfile'

const exportObj = {

    Profile
}

export default exportObj

